export default `/* Ids Accordion Section Component */
:host {
  display: block;
}

:host([hidden]) {
  display: none;
}

:host([grow]) {
  flex-grow: 1;
}

:host([pinned]) {
  overflow-y: auto;
  overflow-x: hidden;
}

.ids-accordion-section {
  display: block;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtYWNjb3JkaW9uIiwic291cmNlcyI6WyJpZHMtYWNjb3JkaW9uLXNlY3Rpb24uc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtBQUNBO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7O0FBR0Y7RUFDRSIsInNvdXJjZXNDb250ZW50IjpbIi8qIElkcyBBY2NvcmRpb24gU2VjdGlvbiBDb21wb25lbnQgKi9cbjpob3N0IHtcbiAgZGlzcGxheTogYmxvY2s7XG59XG5cbjpob3N0KFtoaWRkZW5dKSB7XG4gIGRpc3BsYXk6IG5vbmU7XG59XG5cbjpob3N0KFtncm93XSkge1xuICBmbGV4LWdyb3c6IDE7XG59XG5cbjpob3N0KFtwaW5uZWRdKSB7XG4gIG92ZXJmbG93LXk6IGF1dG87XG4gIG92ZXJmbG93LXg6IGhpZGRlbjtcbn1cblxuLmlkcy1hY2NvcmRpb24tc2VjdGlvbiB7XG4gIGRpc3BsYXk6IGJsb2NrO1xufVxuIl19 */`;
